<template>
    <div class="error-page">
        <patterned-hero-section
            :title="errorMessage"
        >
            <p>
                {{ $snippet('perhaps_you_could', 'perhaps you could') }}
                <a :href="$route.fullPath" v-test:reloadLink>{{ $snippet('try_again', 'try again') }}</a>,
                {{ $snippet('or_return_to_the', 'or return to the') }}
                <a href="/" v-test:homepageLink>{{ $snippet('homepage_link_text', 'homepage?') }}</a>
            </p>
        </patterned-hero-section>
    </div>
</template>

<script>
    import PatternedHeroSection from '../../organisms/PatternedHeroSection/PatternedHeroSection';

    export default {
        name: 'error-page',

        components: { PatternedHeroSection },

        props: {
            error: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Return the error message copy.
             *
             * @returns {string}
             */
            errorMessage() {
                if (this.error?.statusCode === 404) {
                    return this.$snippet('error_404_message', '404 - the page you requested could not be found');
                }

                return this.$snippet('error_generic_message', 'sorry, there was a problem loading the page you requested');
            },
        },
    };
</script>
